import { useEffect } from 'react'

import { adoptAccountAssetType, reportAppliedAssetType } from './rememberedAssetType'

const useRememberedAssetType = (pageConfig) => {
  const accountAssetType = pageConfig?.searchAssetType

  useEffect(() => {
    reportAppliedAssetType()
  }, [])

  useEffect(() => {
    adoptAccountAssetType(accountAssetType)
  }, [accountAssetType])
}

export default useRememberedAssetType
